import React from 'react';
import { Star, Quote, Phone } from 'lucide-react';
import { reviews, businessInfo } from '../data/mock';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';

const ReviewsSection = () => {
  return (
    <section id="reviews" className="py-20 md:py-28 bg-slate-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="inline-block text-amber-600 font-semibold text-sm uppercase tracking-wider mb-3">
            Customer Reviews
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 mb-4">
            What Our Customers Say
          </h2>
          <div className="flex items-center justify-center gap-3">
            <div className="flex">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-6 h-6 fill-amber-400 text-amber-400" />
              ))}
            </div>
            <span className="text-lg text-slate-600 font-medium">
              {businessInfo.rating} rating from {businessInfo.reviewCount} reviews
            </span>
          </div>
        </div>

        {/* Reviews Grid */}
        <div className="grid md:grid-cols-3 gap-6 mb-12">
          {reviews.map((review) => (
            <Card
              key={review.id}
              className="bg-white border-slate-200 hover:shadow-xl transition-all duration-300 group"
            >
              <CardContent className="p-6">
                {/* Quote Icon */}
                <div className="w-10 h-10 bg-amber-100 rounded-full flex items-center justify-center mb-4">
                  <Quote className="w-5 h-5 text-amber-600" />
                </div>

                {/* Stars */}
                <div className="flex mb-4">
                  {[...Array(review.rating)].map((_, i) => (
                    <Star key={i} className="w-4 h-4 fill-amber-400 text-amber-400" />
                  ))}
                </div>

                {/* Review Text */}
                <p className="text-slate-600 leading-relaxed mb-6 line-clamp-6">
                  "{review.text}"
                </p>

                {/* Reviewer */}
                <div className="flex items-center gap-3 pt-4 border-t border-slate-100">
                  <div className="w-10 h-10 bg-slate-900 rounded-full flex items-center justify-center">
                    <span className="text-white font-bold text-sm">
                      {review.name.split(' ').map(n => n[0]).join('')}
                    </span>
                  </div>
                  <div>
                    <p className="font-semibold text-slate-900">{review.name}</p>
                    <p className="text-sm text-slate-500">Verified Customer</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center">
          <p className="text-slate-600 mb-4">Join our satisfied customers</p>
          <a href={businessInfo.phoneLink}>
            <Button size="lg" className="bg-amber-500 hover:bg-amber-400 text-slate-900 font-bold gap-2 px-8">
              <Phone className="w-5 h-5" />
              Call {businessInfo.phone}
            </Button>
          </a>
        </div>
      </div>
    </section>
  );
};

export default ReviewsSection;
